// extracted by mini-css-extract-plugin
module.exports = {"Start":"Start_Start__2YUL-"};